import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router';
import createStore from './store/createStore';
import { locationChange } from './store/location';
import { createAppRouter } from './router';
import { trackPageview } from './services/analytics';

const store = createStore(window.___INITIAL_STATE__);
const router = createAppRouter();

// Keep the redux location slice in sync and restore the classic
// scroll-to-top + pageview-on-navigation behaviour (was Router onUpdate).
store.dispatch(locationChange(router.state.location));
let lastPath = router.state.location.pathname;
trackPageview(lastPath);
router.subscribe((state) => {
  if (state.location.pathname !== lastPath) {
    lastPath = state.location.pathname;
    store.dispatch(locationChange(state.location));
    window.scrollTo(0, 0);
    trackPageview(lastPath);
  }
});

createRoot(document.getElementById('root')).render(
  <div style={{ height: '100%', overflowY: 'hidden' }}>
    <Provider store={store}>
      <RouterProvider router={router} />
    </Provider>
  </div>
);
